import { useState, useEffect, useCallback } from 'react';

export const useThreadCollapse = (comments) => {
  const [collapsedThreads, setCollapsedThreads] = useState(() => new Set());

  // Update collapsedThreads when comments change to collapse all by default
  useEffect(() => {
    const threadIds = new Set();
    const addThreadIds = (items) => {
      items?.forEach(item => {
        if (item.replies?.length > 0) {
          threadIds.add(item.id);
          addThreadIds(item.replies);
        }
      });
    };
    addThreadIds(comments);
    setCollapsedThreads(threadIds);
  }, [comments]);

  const toggleThread = useCallback((threadId, e) => {
    e?.stopPropagation();
    setCollapsedThreads(prev => {
      const newSet = new Set(prev);
      if (newSet.has(threadId)) {
        newSet.delete(threadId);
      } else {
        newSet.add(threadId);
      }
      return newSet;
    });
  }, []);

  const expandThreads = useCallback((threadIds) => {
    setCollapsedThreads(prev => {
      const newSet = new Set(prev);
      threadIds.forEach(id => newSet.delete(id));
      return newSet;
    });
  }, []);

  return {
    collapsedThreads,
    toggleThread,
    expandThreads
  };
};
